import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const OneProductSettingsComponent = ({ selectOneSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Enable Candidate In Footer"
                    name="EnableCandidateInFooter"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'WebsiteSettings.EnableCandidateInFooter',
                        selectOneSettings?.WebsiteSettings
                    )
                    }}
                    type="checkbox"
                    value={selectOneSettings?.WebsiteSettings?.EnableCandidateInFooter}
                />  
                <InputContainer
                    label="Enable ONE User In Footer"
                    name="EnableONEUserInFooter"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'WebsiteSettings.EnableONEUserInFooter',
                        selectOneSettings?.WebsiteSettings
                    )
                    }}
                    type="checkbox"
                    value={selectOneSettings?.WebsiteSettings?.EnableONEUserInFooter}
                /> 

                 <InputContainer
                    label="Enable Market Place In Header"
                    name="EnableMarketPlaceInHeader"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'WebsiteSettings.EnableMarketPlaceInHeader',
                        selectOneSettings?.WebsiteSettings
                    )
                    }}
                    type="checkbox"
                    value={selectOneSettings?.WebsiteSettings?.EnableMarketPlaceInHeader}
                /> 
            </div>
            }
        expandedPanel="One Settings"
        headerTitle="One Settings"
        />
        </>
  )
}
export default OneProductSettingsComponent;
